module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._l((_vm.colors), function(color, idx) {
    return _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedColor),
        expression: "selectedColor"
      }],
      key: idx,
      ref: "inputradio",
      refInFor: true,
      staticClass: "hidden_field",
      attrs: {
        "type": "radio",
        "name": "color"
      },
      domProps: {
        "value": color.value,
        "checked": _vm._q(_vm.selectedColor, color.value)
      },
      on: {
        "change": function($event) {
          _vm.selectedColor = color.value
        }
      }
    })
  }), _vm._v(" "), _c('ul', {
    staticClass: "color-picker"
  }, _vm._l((_vm.colors), function(color, idx) {
    return _c('li', {
      key: color.value,
      staticClass: "color-picker__color hint--top",
      class: {
        'isActive': _vm.isSelectedColor(color.value)
      },
      style: ({
        'backgroundColor': color.value
      }),
      attrs: {
        "aria-label": color.title
      },
      on: {
        "click": function($event) {
          return _vm.setColor(idx)
        }
      }
    })
  }), 0)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f581df80!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Subjects/ColorPicker.vue
// module id = 2166
// module chunks = 1